import { render, staticRenderFns } from "./draw.vue?vue&type=template&id=bcd60848&scoped=true&"
import script from "./draw.vue?vue&type=script&lang=js&"
export * from "./draw.vue?vue&type=script&lang=js&"
import style0 from "./draw.vue?vue&type=style&index=0&id=bcd60848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd60848",
  null
  
)

export default component.exports